import React, { FC, useEffect, useState } from "react";
import InDetailView from "../../templates/InDetailView";
import CalendarView from "./calendarView";
import ViewWorkingDays from "./viewWorkingDays";
import ViewHolidays from "./viewHolidays";
import ViewAssociatedProjects from "./viewAssociatedProjects";
import ViewWorkingHours from "./viewWorkingHours";
import { ApiResponse } from "../../../../api/master/axiosIndex";
import { calendarApis } from "../../../../api/Calendar";

const CalendarViewModal: FC<{ fullData: any; refresh: () => void }> = ({
  fullData,
  refresh,
}) => {
  const [tab, setTab] = useState(fullData.tab);
  const [idData, setIdData] = useState();
  console.log("fullData", fullData);
  useEffect(() => {
    setTab(fullData.tab);
  }, [fullData]);

  useEffect(() => {
    fetchDataById();
  }, [tab,refresh]);

  const fetchDataById = async () => {
    try {
      const apiResponse: ApiResponse = await calendarApis.getCalendarById(
        fullData.data.calendarId
      );
      const { data, status } = apiResponse;
      if (status) {
        setIdData(data);
      }
    } catch (error) {}
  };

  return (
    <InDetailView
      body={{
        tabOptions: {
          tab: tab,
          setTab: setTab,
          tabs: [
            {
              label: "View",
              tabKey: "view",
              content: <CalendarView fullData={idData} refresh={refresh} />,
            },
            {
              label: "View Work Days",
              tabKey: "workDays",
              content: <ViewWorkingDays fullData={idData} />,
            },
            {
              label: "View Work Hours",
              tabKey: "workHours",
              content: <ViewWorkingHours fullData={idData} />,
            },
            {
              label: "View Holidays",
              tabKey: "holidays",
              content: <ViewHolidays fullData={idData} />,
            },
            {
              label: "Associated Projects",
              tabKey: "associatedProjects",
              content: <ViewAssociatedProjects fullData={idData} />,
            },
          ],
        },
      }}
    />
  );
};

export default CalendarViewModal;
